import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import IconPanel from '../../../../../../IconPanel';
import completeIcon from '../../../../../../../images/icons/Complete.svg';

type Props = {
  company: string;
};

const CandidateStorySuccess = ({ company }: Props) => (
  <IconPanel
    data-testid='candidate-story-success'
    translationKey='components.Report.CandidateStories.success'
    detailsCustomValue={{ company }}
    icon={
      <img
        src={completeIcon}
        alt={i18n.getStr('components.Report.CandidateStories.success.sent')}
      />
    }
    detailsCentered
  />
);

export default i18n.renderTranslation()(CandidateStorySuccess);
